module.exports = __webpack_public_path__ + "static/media/certificateImg.cb10910d.png";